export enum BroadcastListeners {
  REWARDS_PROGRAM_PREFERENCE_LISTENER = 'rewards program preference listener',
}

export interface BroadCastListenerPayload<T> {
  listener: BroadcastListeners;
  data: T | null;
}
